// 禁用数字输入框滚轮事件
export function disableNumberWheel() {
  document.addEventListener(
    "wheel",
    (event) => {
      const target = event.target;

      if (
        target instanceof HTMLElement &&
        target.tagName === "INPUT" &&
        target.type === "number"
      ) {
        event.preventDefault();
      }
    },
    { passive: false },
  );
}
